import React from 'react';

const ICON = {
    'application/pdf': 'icon-file-pdf',
    'application/msword': 'icon-file-word',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'icon-file-word',
    'application/vnd.ms-excel': 'icon-file-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'icon-file-excel',
    'text/csv': 'icon-file-excel',
};

class File extends React.Component {
    render() {
        const { entity, readOnly } = this.props;
        const {
            name, type, src, date,
        } = entity.getData();
        const dateString = new Date(date).toDateString();
        const className = src ? 'file-info' : 'file-info loading';
        const fileInfo = src ? dateString : 'Loading...';
        const fileIcon = ICON[type] || 'icon-file';

        const content = (
            <div className="file" spellCheck="false">
                <span className={`icon ${fileIcon}`} />
                <h4 className="file__name">
                    {name}
                    <span className={className}>{fileInfo}</span>
                </h4>
            </div>
        );

        if (readOnly) {
            return (
                <a href={src} target="_blank" rel="noopener noreferrer">
                    {content}
                </a>
            );
        }
        return content;
    }
}

export default File;
